import React from 'react';
import { Link } from 'react-router-dom';
import Util from '../../../Util';

const PatientInfo = (props) => {
    const patient = props.patient;
    return (  
        <div className="card widget-profile pat-widget-profile">
            <div className="card-body">
                <div className="pro-widget-content">
                    <div className="profile-info-widget">
                    <Link className="booking-doc-img" to={
                                                    {
                                                        pathname:'/PatientProfile',
                                                        state: {
                                                            patientId: patient.patientId
                                                        }
                                                    }
                                                }>
                            <img src={Util.loadImage(patient.profileImage)} alt="User Image" />
                        </Link>
                        <div className="profile-det-info">
                            <h3><Link to={
                                    {
                                        pathname:'/PatientProfile',
                                        state: {
                                            patientId: patient.patientId
                                        }
                                    }
                                }>{patient.firstName} {patient.lastName}</Link></h3>
                            <div className="patient-details">
                                <h5><b>Patient ID :</b> {patient.patientNumber}</h5>
                                <h5 className="mb-0"><i className="fas fa-map-marker-alt"></i> {patient.state} {patient.country}</h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="patient-info">
                    <ul>
                        <li>Phone <span>{patient.phone}</span></li>
                        <li>Age <span>{Util.getAge(new Date(patient.dob), new Date())}</span></li>
                        <li>Blood Group <span>{patient.bloodGroup}</span></li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
 
export default PatientInfo;